module.exports = __webpack_public_path__ + "img/detractors-promoters.996a1318.svg";